const tableActionTypes = {
    UPDATE_TABLE: "UPDATE_TABLE",
};

export default tableActionTypes;
